module.exports = __webpack_public_path__ + "static/media/wx2.1476d9f0.png";